/* eslint-disable no-param-reassign */
import { action, Action } from "easy-peasy";
import {
  CMSApiGeneral,
  CMSApiComponentsFooter,
  CMSApiCTAFooter,
  CMSApiCTASmall,
  CMSApiCTAMedium,
  CMSApiCTALarge,
  CMSApiComponentsHeader,
  CMSApiPagesLandingExplorer,
  CMSApiPagesLandingPublisher,
  CMSPagesExplorer,
  CMSPagesExplorerLocations,
  CMSPagesExplorerOrganisations,
  CMSPagesExplorerSectors,
  CMSPagesExplorerActivities,
  CMSPagesExplorerFavourites,
  CMSPagesPublisher,
  CMSPagesPublisherPublish,
  CMSPagesDataHub,
  CMSPagesLogin,
  CMSPagesAccountProfile,
  CMSPagesDataServices,
  CMSCollectionAbout,
  CMSCollectionFrequentlyAskedQuestions,
} from "../../interfaces/cms";

export interface CMSDataValueModel {
  componentsFooter: CMSApiComponentsFooter | null;
  componentsHeader: CMSApiComponentsHeader | null;
  componentsDetailPageNotFoundModal: any | null;
  componentsGenericBlockItem: any | null;
  pagesLandingExplorer: CMSApiPagesLandingExplorer | null;
  pagesLandingPublisher: CMSApiPagesLandingPublisher | null;
  pagesExplorer: CMSPagesExplorer | null;
  pagesExplorerActivity: any | null;
  pagesExplorerLocation: any | null;
  pagesExplorerOrganisation: any | null;
  pagesExplorerSector: any | null;
  pagesExplorerLocations: CMSPagesExplorerLocations | null;
  pagesExplorerOrganisations: CMSPagesExplorerOrganisations | null;
  pagesExplorerSectors: CMSPagesExplorerSectors | null;
  pagesExplorerActivities: CMSPagesExplorerActivities | null;
  pagesExplorerFavourites: CMSPagesExplorerFavourites | null;
  pagesPublisher: CMSPagesPublisher | null;
  pagesPublisherPublish: CMSPagesPublisherPublish | null;
  pagesDataHub: CMSPagesDataHub | null;
  pagesLogin: CMSPagesLogin | null;
  pagesAccountProfile: CMSPagesAccountProfile | null;
  pagesDataServices: CMSPagesDataServices | null;
  collectionAbout: CMSCollectionAbout[] | null;
  collectionFrequentlyAskedQuestions: CMSCollectionFrequentlyAskedQuestions | null;
  ctaFooter: CMSApiCTAFooter | null;
  ctaSmall: CMSApiCTASmall | null;
  ctaMedium: CMSApiCTAMedium | null;
  ctaLarge: CMSApiCTALarge | null;
  general: CMSApiGeneral | null;
}

export interface CMSDataModel {
  value: CMSDataValueModel;
  setValue: Action<CMSDataModel, CMSDataValueModel>;
}

export const CMSData: CMSDataModel = {
  value: {
    componentsFooter: null,
    componentsHeader: null,
    componentsDetailPageNotFoundModal: null,
    componentsGenericBlockItem: null,
    pagesLandingExplorer: null,
    pagesLandingPublisher: null,
    pagesExplorer: null,
    pagesExplorerActivity: null,
    pagesExplorerLocation: null,
    pagesExplorerOrganisation: null,
    pagesExplorerSector: null,
    pagesExplorerLocations: null,
    pagesExplorerOrganisations: null,
    pagesExplorerSectors: null,
    pagesExplorerActivities: null,
    pagesExplorerFavourites: null,
    pagesPublisher: null,
    pagesPublisherPublish: null,
    pagesDataHub: null,
    pagesLogin: null,
    pagesAccountProfile: null,
    pagesDataServices: null,
    collectionAbout: null,
    collectionFrequentlyAskedQuestions: null,
    ctaFooter: null,
    ctaSmall: null,
    ctaMedium: null,
    ctaLarge: null,
    general: null,
  },
  setValue: action((state, payload: CMSDataValueModel) => {
    state.value = payload;
  }),
};

export interface ShowHeaderBannerModel {
  value: boolean;
  setValue: Action<ShowHeaderBannerModel, boolean>;
}

export const ShowHeaderBanner: ShowHeaderBannerModel = {
  value: true,
  setValue: action((state, payload: boolean) => {
    state.value = payload;
  }),
};
